/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Input } from '@angular/core';
import { LiteralsService } from '../../services/literals-service';
import { LiteralsWords } from 'src/app/i18n/literals.model';

@Component({
  selector: 'tgv-productimage',
  standalone: false,
  templateUrl: './productimage.component.html',
  styleUrl: './productimage.component.css'
})
export class ProductimageComponent {
  @Input() imageUrl: string | null = null;
  literals: LiteralsWords;

  constructor(
    private readonly literalsService: LiteralsService
  ){
    this.literals = this.literalsService.getLiteralModule();
  }
}


